import { isCelsiusTemperatureUnit } from "user/tools/common"

export function getTemperatureUnitSymbol(): string {
  return isCelsiusTemperatureUnit() ? "°C" : "°F"
}

export function getConvertedTemperature(celsiusTemp: number | null): number | null {
  if (celsiusTemp === null) {
    return null
  }
  return isCelsiusTemperatureUnit() ? celsiusTemp : Math.round((celsiusTemp * 9) / 5 + 32)
}

export function getCelsiusFromFahrenheight(fahrenheightTemp: number): number {
  return ((fahrenheightTemp - 32) * 5) / 9
}
